import { DropDownListDTO } from './../../../entity/dto/dropdownlist.component';
import { GeneralService } from 'src/app/services/general.service';
import { NotificationService } from './../../../services/notification.service';
import { FormularioService } from './../../../services/formulario.service';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AbstractControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { GeneralComponent } from 'src/app/shared/general.component';
import { HttpErrorResponse } from '@angular/common/http';
import { ActionMessage, TypeMessage } from 'src/app/entity/enum/enum-notification';
import { take } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';


@Component({
    // tslint:disable-next-line: component-selector
    selector: 'app-et004-card-I',
    templateUrl: './et004-card-I.component.html'
})

export class Et004CardIComponent extends GeneralComponent implements OnInit {

    public formulario?: FormGroup;
    public listSite?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listTipoProduto?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listHibrido?: Array<DropDownListDTO> = new Array<DropDownListDTO>();

    public listTipoTratamento?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listSiteOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listTipoProdutoOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listHibridoOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listPeneiraOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listTipoTratamentoOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public notificationBo = false
    public listPeneira?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listLinhaReprocessamentoOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listLinhaReprocessamento?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listTurnoOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listTurno?: Array<DropDownListDTO> = new Array<DropDownListDTO>();


    @Output() mkCalc = new EventEmitter();
    @Output() mkCalcII = new EventEmitter();

    et004CardIComponent: any;
    listOptionsLotePosLimpLin: DropDownListDTO[];
    listOptionsOriginal: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    isUnlockerInput: boolean;
    isShowLotePosLimpeza: boolean = true;
    listSafra
    listSafraOriginal: DropDownListDTO[];

    // tslint:disable-next-line: max-line-length
    constructor(protected formularioService: FormularioService, protected formBuilder: FormBuilder, protected notificationService: NotificationService, protected generalService: GeneralService, public dialog: MatDialog) {
        super('Dados Iniciais', false);
        this.formulario = this.formBuilder.group({
            site: [null, []],
            controle_analise: [null, []],
            safra: [null, [Validators.required, Validators.pattern(this.regexSafra)]],
            // data_tratamento: [new Date().toLocaleDateString('pt-br'), []],
            // hora_tratamento: [null, [Validators.pattern(this.regexHour)]],
            // tipo_produto: [null, []],
            hibrido: [null, []],
            peneira: [null, []],
            origem: [null, []],
            umidade: [null, []],
            tipo_tratamento: [null, []],
            peso_dez_mil_sementes: [null, []],
            num_sementes_contador: [10000, []],
            num_sementes: [null, []],
            //data_contagem_sessenta_mil_sementes: [null, [Validators.pattern(this.regexDate)]],
            //hora_contagem_sessenta_mil_sementes: [null, [Validators.pattern(this.regexHour)]],
            peso_liquido_regulagem_cbt: [null, []],
            peso_mil_sementes: [null, []],
            lote_cs: [null, []],
            ca_limpeza: [null, [Validators.required]],
            lote_pos_limpeza_de_linha: [null, []],
            turno: [null, []],

        });
    }

    async ngOnInit(): Promise<void> {
        await this.getLists();

    }


    changeCollapse(): void {
        this.collapseCard = this.collapseCard ? false : true;
    }

    hasErrorFormControl(campoFormulario?: AbstractControl): string {
        return this.formularioService.hasErrorFormControl(campoFormulario);
    }

    async getLists(): Promise<void> {
        await Promise.all([this.getListSite(), this.getListTipoProduto(), this.getListHibrido(), this.getListPeneira(), this.getListTipoTratamento(), this.getListSafra(), this.getListOptionLimpLin()]);
        this.getListTurno()
    }

    async getListSafra(): Promise<void> {
        await this.formularioService
            .getListDropDownList('qua007', 'safra')
            .pipe(take(1))
            .toPromise()
            .then((response) => {
                if (!!response?.data) {
                    this.listSafra = this.generalService.orderByDropDownList(
                        response.data as DropDownListDTO[]
                    );
                    this.listSafraOriginal = this.listSafra;
                }
            })
            .catch(async (error: HttpErrorResponse) => {
                this.notificationService.showNotificationError(
                    error,
                    '',
                    TypeMessage.ListErrorSafra
                );
            });
    }

    async createFilterSafra(value?: string): Promise<void> {
        if (!!value && value.length > 0) {
            if (
                this.listSafraOriginal.filter((x) =>
                    x.name?.toLowerCase().includes(value?.toLowerCase())
                ).length > 0
            ) {
                this.listSafra = this.listSafraOriginal.filter((x) =>
                    x.name?.toLowerCase().includes(value?.toLowerCase())
                );
            } else {
                this.listSafra = this.listSafraOriginal;
            }
        } else {
            this.listSafra = this.listSafraOriginal;
        }
    }

    async getListSite(): Promise<void> {
        this.listSite = this.generalService.getListSiteRecebimento();
        this.listSiteOriginal = this.listSite;
        // await this.formularioService.getListDropDownList('qua007', 'site_origem').pipe(take(1)).toPromise().then(response => {
        //     if (!!response?.data) {
        //         this.listSite = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
        //         this.listSiteOriginal = this.listSite;
        //     }
        // }).catch(async (error: HttpErrorResponse) => {
        //     this.notificationService.showNotificationError(error, '', TypeMessage.ListErrorSiteOrigem);
        // });
    }

    async getListTipoProduto(): Promise<void> {
        await this.formularioService.getListDropDownList('et004', 'tipo_produto').pipe(take(1)).toPromise().then(response => {
            if (!!response?.data) {
                this.listTipoProduto = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
                this.listTipoProdutoOriginal = this.listTipoProduto;
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, '', TypeMessage.ListErrorTipoProduto);
        });
    }

    async getListHibrido(): Promise<void> {
        await this.formularioService.getListDropDownList('qua007', 'hibrido_rnc').pipe(take(1)).toPromise().then(response => {
            if (!!response?.data) {
                this.listHibrido = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
                this.listHibridoOriginal = this.listHibrido;
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, '', TypeMessage.ListErrorHibrido);
        });
    }

    async getListPeneira(): Promise<void> {
        await this.formularioService.getListDropDownList('cd003', 'peneira').pipe(take(1)).toPromise().then(response => {
            if (!!response?.data) {
                this.listPeneira = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
                this.listPeneiraOriginal = this.listPeneira;
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, '', TypeMessage.ListErrorHibrido);
        });
    }

    async getListTipoTratamento(): Promise<void> {
        await this.formularioService.getListDropDownList('et004', 'tipo_tratamento').pipe(take(1)).toPromise().then(response => {
            if (!!response?.data) {
                this.listTipoTratamento = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
                this.listTipoTratamentoOriginal = this.listTipoTratamento;
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, '', TypeMessage.ListErrorTipoTratamento);
        });
    }
    private async getListOptionLimpLin(): Promise<void> {
        await this.formularioService
            .getListDropDownList('qua007', 'ultima_carga')
            .pipe(take(1))
            .toPromise()
            .then((response: any) => {
                if (!!response?.data) {
                    this.listOptionsOriginal =
                        this.generalService.orderByDropDownList(
                            response.data as DropDownListDTO[]
                        );
                    this.listOptionsLotePosLimpLin = this.listOptionsOriginal;

                }
            })
            .catch(async (error: HttpErrorResponse) => {
                this.notificationService.showNotificationError(error, error.message);
            });
    }
    async createFilterSite(value: string): Promise<void> {
        if (!!value && value.length > 0) {
            if (this.listSiteOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listSite = this.listSiteOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listSite = this.listSiteOriginal;
            }
        } else {
            this.listSite = this.listSiteOriginal;
        }
    }

    async createFilterTipoProduto(value?: string): Promise<void> {
        if (!!value && value.length > 0) {
            if (this.listTipoProdutoOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listTipoProduto = this.listTipoProdutoOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listTipoProduto = this.listTipoProdutoOriginal;
            }
        } else {
            this.listTipoProduto = this.listTipoProdutoOriginal;
        }
    }

    async createFilterHibrido(value?: string): Promise<void> {
        if (!!value && value.length > 0) {
            if (this.listHibridoOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listHibrido = this.listHibridoOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listHibrido = this.listHibridoOriginal;
            }
        } else {
            this.listHibrido = this.listHibridoOriginal;
        }
    }

    async createFilterPeneira(value?: string): Promise<void> {
        if (!!value && value.length > 0) {
            if (this.listPeneiraOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listPeneira = this.listPeneiraOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listPeneira = this.listPeneiraOriginal;
            }
        } else {
            this.listPeneira = this.listPeneiraOriginal;
        }
    }

    async createFilterTipoTratamento(value?: string): Promise<void> {
        if (!!value && value.length > 0) {
            if (this.listTipoTratamentoOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listTipoTratamento = this.listTipoTratamentoOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listTipoTratamento = this.listTipoTratamentoOriginal;
            }
        } else {
            this.listTipoTratamento = this.listTipoTratamentoOriginal;
        }
    }

    async makeCalculations(): Promise<void> {
        this.mkCalc.emit();
    }

    async makeCalculationsII(): Promise<void> {
        this.mkCalcII.emit();
    }

    onSelectLotePos() {
        this.mkCalc.emit();
    }

    //   async makeCalculationsI(): Promise<void> {
    //     this.mkCalcI.emit();
    // }

    async changeTipoTratamento($event: any): Promise<void> {
        await this.makeCalculations();
        await this.makeCalculationsII();
    }

    alertaPesoLiquidoRegulagemCBT200() {
        const pesoLiquido = this.formulario.get('peso_liquido_regulagem_cbt').value;
        if (pesoLiquido <= 9.5 || pesoLiquido > 26) {
            this.notificationService.sendNotification('', TypeMessage.CalcAlertLiquidoRegulagemCbt, ActionMessage.Warning);
        }
    }


    async getListTurno(): Promise<void> {
        await this.formularioService.getListDropDownList('cd001_repasse', 'turno').pipe(take(1)).toPromise().then(response => {
            if (!!response?.data) {
                this.listTurno = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
                this.listTurnoOriginal = this.listTurno;
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, '', TypeMessage.ListErrorTurno);
        });
    }

    async createFilterLinhaReprocessamento(value?: string): Promise<void> {
        if (!!value && value.length > 0) {
            if (this.listLinhaReprocessamentoOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listLinhaReprocessamento = this.listLinhaReprocessamentoOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listLinhaReprocessamento = this.listLinhaReprocessamentoOriginal;
            }
        } else {
            this.listLinhaReprocessamento = this.listLinhaReprocessamentoOriginal;
        }
    }

    async createFilterTurno(value?: string): Promise<void> {
        if (!!value && value.length > 0) {
            if (this.listTurnoOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listTurno = this.listTurnoOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listTurno = this.listTurnoOriginal;
            }
        } else {
            this.listTurno = this.listTurnoOriginal;
        }
    }
}


